import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectSpread2.js";
import { HighlightSerif as r } from "../primitives/highlight-serif.js";
import { dampened as i, revealItem as a, staggerContainer as o } from "../../motion/transitions.js";
import * as s from "react";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
import { motion as d, useReducedMotion as f } from "motion/react";
//#region src/components/composed/signature-headline.tsx
var p = [
	"text",
	"highlight",
	"as",
	"size",
	"tone",
	"highlightTone",
	"animate",
	"className"
], m = {
	xl: "text-[42px] sm:text-[56px] lg:text-[72px] leading-[1.0]",
	lg: "text-[34px] sm:text-[44px] lg:text-[52px] leading-[1.05]",
	md: "text-[26px] sm:text-[32px] lg:text-[38px] leading-[1.15]",
	sm: "text-[20px] sm:text-[24px] lg:text-[28px] leading-[1.25]",
	none: ""
}, h = {
	ink: "text-neutral-900",
	white: "text-white",
	inherit: ""
}, g = /^[.,!?;:)\]}…”’'"]+/, _ = {
	hidden: { opacity: 0 },
	show: {
		opacity: 1,
		transition: i
	}
};
function v(e, t) {
	var n, r, i, a, o, s;
	let c = (e) => e.split(/\s+/).filter(Boolean).map((e) => ({
		kind: "text",
		value: e
	})), l = t ? e.indexOf(t) : -1;
	if (t && l < 0 && process.env.NODE_ENV !== "production" && console.warn(`[SignatureHeadline] highlight ${JSON.stringify(t)} does not appear in text ${JSON.stringify(e)} — rendering without the italic. The highlight must match the headline verbatim.`), !t || l < 0) return c(e);
	let u = e.slice(0, l), d = e.slice(l + t.length), f = (n = (r = d.match(g)) == null ? void 0 : r[0]) == null ? "" : n, p = d.slice(f.length), m = c(u), h = c(p), _ = u !== "" && !/\s$/.test(u), v = p !== "" && !/^\s/.test(p), y = _ ? (i = (a = m.pop()) == null ? void 0 : a.value) == null ? "" : i : "", b = v ? (o = (s = h.shift()) == null ? void 0 : s.value) == null ? "" : o : "";
	return [
		...m,
		{
			kind: "highlight",
			pre: y,
			value: t + f,
			post: b
		},
		...h
	];
}
var y = s.forwardRef((i, g) => {
	let { text: y, highlight: b, as: x = "h1", size: S = "xl", tone: C = "ink", highlightTone: w = "ink", animate: T = !1, className: E } = i, D = t(i, p), O = f(), k = x === "h1", A = s.useMemo(() => v(y, b), [y, b]), j = T && !O, M = e("font-gotham font-black text-balance", m[S], h[C], E), N = (e) => e.kind === "text" ? e.value : /* @__PURE__ */ u(c, { children: [
		e.pre,
		/* @__PURE__ */ l(r, {
			tone: k ? w : "ink",
			children: e.value
		}),
		e.post
	] });
	if (!j) return /* @__PURE__ */ l(x, n(n({
		ref: g,
		className: M
	}, D), {}, { children: A.map((e, t) => /* @__PURE__ */ u(s.Fragment, { children: [t > 0 ? " " : null, N(e)] }, t)) }));
	let P = d[x];
	return /* @__PURE__ */ l(P, n(n({
		ref: g,
		className: M,
		variants: o(.055, .08),
		initial: "hidden",
		animate: "show"
	}, D), {}, { children: A.map((e, t) => /* @__PURE__ */ u(s.Fragment, { children: [t > 0 ? " " : null, /* @__PURE__ */ l(d.span, {
		variants: e.kind === "highlight" ? _ : a,
		className: e.kind === "highlight" ? void 0 : "inline-block",
		children: N(e)
	})] }, t)) }));
});
y.displayName = "SignatureHeadline";
//#endregion
export { y as SignatureHeadline, v as splitHeadline };

//# sourceMappingURL=signature-headline.js.map